import { useEffect, useState } from "react";

export const useIsBelowBreakpoint = (breakpointPx: number) => {
  const [isBelow, setIsBelow] = useState(() => window.innerWidth < breakpointPx);

  useEffect(() => {
    const onResize = () => setIsBelow(window.innerWidth < breakpointPx);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpointPx]);

  return isBelow;
};
